import React from 'react';
import c from 'classnames';

import { SearchResults } from '@uncinc/react-searchkit';
import type { Results } from '@uncinc/react-searchkit/types';

import EmptyState from './EmptyState';
import renderItem from './renderItem';

const SearchAllContentResults: React.FC<Omit<Results, 'renderItem' | 'emptyState'>> = ({
  className,
  ...props
}) => (
  <SearchResults
    className={c('SearchAllContent__Results', className)}
    renderItem={renderItem}
    emptyState={<EmptyState />}
    {...props}
  />
);

export default SearchAllContentResults;
